module.exports = "<div class=\"loading-bar\" #bar>\r\n    <div class=\"loading-bar__inner\"></div>\r\n</div>\r\n"